// utils/auth.js (or context/auth.js)
export const isAuthenticated = () => {
  return !!localStorage.getItem("token"); // or check a proper auth state
};
